import instance from 'api';
import { IConsultingTypeModel, INewConsulting } from 'interfaces';

export const getConsultingList = () => {
  return instance()
    .post<IConsultingTypeModel[]>('/dictionary/consultationTypes', {})
    .then((response) => response.data);
};

export const createConsulting = (data: INewConsulting) => {
  return instance()
    .post('/consultation/save', data)
    .then((response) => response.data);
};
